// extracted by mini-css-extract-plugin
export default {"cta":"cK-z","disabled":"dK-z"};